import './alteration-card-list.scss'

import { ReactiveVue } from "@skinsoft/reactive-vue";
import Component from "vue-class-component";
import AlterationCard, { ALTERATION_CARD_ALTERATION_UPDATED, ALTERATION_CARD_DELETE_ALTERATION, AlterationWithThesaurusTerm, MainAlterationCardField } from "../alteration-card";

@Component({
    components: {
        sAlterationCard: AlterationCard,
    },
    props: ['alterations', 'mainField'],
    template: require('./alteration-card-list.html')
})
export default class AlterationCardList extends ReactiveVue {
    private alterations: (AlterationWithThesaurusTerm & { index?: number })[]
    private mainField: MainAlterationCardField

    private ALTERATION_CARD_DELETE_ALTERATION = ALTERATION_CARD_DELETE_ALTERATION
    private ALTERATION_CARD_ALTERATION_UPDATED = ALTERATION_CARD_ALTERATION_UPDATED

    private getAlterationIndex(alteration: AlterationWithThesaurusTerm & { index?: number }, index) {
        return alteration.index ? alteration.index : index
    }
}